import React, { useState, useEffect } from "react";
import DopClaim from "../../hooks/isClaimed2";
import { DopClaim as DopClaim1 } from "../../hooks/isClaimed";
import "./claimschedule.scss";
import { useWeb3React } from "@web3-react/core";
import Countdown from "react-countdown";
import { useHistory } from "react-router-dom";
import LastClaimedDopMonth from "../../hooks/LastClaimedMonth";

const List = ({ item, index, five, eight, last, lastClaimedMonth }) => {
  const [tokenCl, setTokenCl] = useState(false);
  const { IsClaimed2 } = DopClaim();
  const { IsClaimed } = DopClaim1();
  const { account } = useWeb3React();
  const [avai, setAvai] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (account && item?.claimContract) {
      isDopClaimed();
    } else {
      setTokenCl(undefined);
    }
  }, [account]);

  const isDopClaimed = async () => {
    try {
      let res = null;
      if (item?.round === 1) {
        res = await IsClaimed2(account, item?.claimContract);
      } else {
        res = await IsClaimed2(account, item?.claimContract);
      }
      if (res) {
        setTokenCl(res);
      } else {
        setTokenCl(false);
      }
    } catch (err) {
      setTokenCl(true);
      console.log("errxxxxx", err);
    }
  };

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      setAvai(true);
      return (
        <h6 className="avail-text" style={{ color: "#329879" }}>
          Available
        </h6>
      );
    }

    // Utility function to format time values
    const formatTime = (value) => String(value).padStart(2, "0");

    return (
      <>
        {[
          { label: "Days", value: days },
          { label: "Hours", value: hours },
          { label: "Minutes", value: minutes },
        ].map(({ label, value }) => (
          <div className="single" key={label}>
            <h6>{formatTime(value)}</h6>
            <p>{label}</p>
          </div>
        ))}
      </>
    );
  };

  const parseDate = (dateString) => {
    // Convert "5:14 27/12/2024" to a valid Date object
    const [time, date] = dateString.split(" ");
    const [hours, minutes] = time.split(":").map(Number);
    const [day, month, year] = date.split("/").map(Number);

    // Create a Date object with the parsed values
    return new Date(year, month - 1, day, hours, minutes);
  };

  const MoveNext = () => {
    localStorage?.setItem("currentObj", JSON.stringify(item));
    history.push("/claimall");
  };

  const checkTime = () => {
    if (!item?.date) return false; // Handle undefined date

    const eventTime = new Date(item.date).getTime(); // Convert to timestamp
    const roundTime = eventTime + 5 * 60 * 1000; // Add 5 minutes
    const currentTime = Date.now(); // Get current timestamp

    console.log("roundTime > currentTime", roundTime < currentTime);

    return roundTime <= currentTime; // Returns true if 5 minutes have passed
  };

  const trunCate = (num) => {
    const truncatedNum = Math.floor(num * 100) / 100;
    return truncatedNum;
  };

  const convertToLocalTime = (utcDate) => {
    const localDate = new Date(utcDate); // Convert to Date object (local time by default)

    // Format the time as per the user's locale
    return localDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // AM/PM format
    });
  };

  return (
    <tr key={index}>
      <td>#{item?.id}</td>
      <td>
        <div className="twice-text">
          <h6>
            {/* {item?.date?.slice(item?.date?.length - 10, item?.date?.length)} */}
            {item?.date?.slice(0, 10)}
          </h6>
          <p>{convertToLocalTime(item.date)}</p>
        </div>
      </td>
      <td style={{ textAlign: "center" }}>{item?.percentage}%</td>
      <td style={{ textAlign: "center" }}>
        {item?.id < 4 ? (
          <div className="timer">
            {tokenCl ? (
              <h6>Claimed</h6>
            ) : (
              <>
                <Countdown own date={new Date(item.date)} renderer={renderer} />
              </>
            )}
          </div>
        ) : (
          <div className="timer">
            {item?.id <= lastClaimedMonth ? (
              <h6>Claimed</h6>
            ) : (
              <>
                <Countdown own date={new Date(item.date)} renderer={renderer} />
              </>
            )}
          </div>
        )}
      </td>
      <td style={{ textAlign: "center" }}>
        {item?.id === 1 ? (
          trunCate(five)
        ) : (
          <>{item?.id === 12 ? trunCate(last) : trunCate(eight)}</>
        )}{" "}
        LEIA
      </td>
      <td>
        {/* {console.log(tokenCl, "tokenCl")} */}
        {item?.id < 4 ? (
          tokenCl === false && avai ? (
            <a onClick={() => MoveNext()} className="btn-claim">
              Claim
            </a>
          ) : index > 0 ? (
            tokenCl ? (
              <a style={{ opacity: 0.5 }} className="btn-claim claimed">
                Claimed
              </a>
            ) : (
              <a style={{ opacity: 0.5 }} className="btn-claim">
                Claim
              </a>
            )
          ) : (
            <a style={{ opacity: 0.5 }} className="btn-claim claimed">
              Claimed
            </a>
          )
        ) : item?.id <= lastClaimedMonth ? (
          <a style={{ opacity: 0.5 }} className="btn-claim claimed">
            Claimed
          </a>
        ) : avai ? (
          <a onClick={() => MoveNext()} className="btn-claim">
            Claim
          </a>
        ) : (
          <a style={{ opacity: 0.5 }} className="btn-claim">
            Claim
          </a>
        )}
      </td>
    </tr>
  );
};

export default List;
